import React from 'react'
import TutorSidebar from '../TutorSidebar/TutorSidebar'
import TutorFooter from '../TutorFooter/TutorFooter'
import { Link } from 'react-router-dom'
import TutorHeader from '../TutorHeader/TutorHeader'

const TutorCourses = () => {
    return (
        <div>

            <section className="after-header">
                {/* Breadcrum Start */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item  ps-5" aria-current="page">
                            <Link to="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </Link>
                            &nbsp;&nbsp;My Courses
                        </li>
                    </ol>
                </nav>
                {/* Breadcrum End */}
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <TutorSidebar />
                        </div>
                        <div className="col-lg-9">
                            <main className="px-3 py-4">
                                <div className="my-courses-sec bg-light">
                                    <div className="row mt-3 justify-content-center" >
                                        <div className="col-lg-6 col-md-6 mb-4 d-flex justify-content-center mt-4">
                                            <Link to="/tutor/add-new-group-course"></Link>
                                            <div className="tutor-card-sec tutor-card-one">
                                                <Link to="/tutor/add-new-group-course">
                                                    <div className="img-sec">
                                                        <img
                                                            src="/assets/img/user/group-img.png"
                                                            className="img-fluid"
                                                        />
                                                    </div>
                                                </Link>
                                                <Link to="#" className="tutor-text">
                                                    Create Group Course
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mt-3">
                                        {/* <div className="col-lg-6 col-md-6 mb-4 d-flex justify-content-center">
                                            <Link to="/tutor/add-new-course-one-to-one"></Link>
                                            <div className="tutor-card-sec tutor-card-one">
                                                <Link to="/tutor/add-new-course-one-to-one">
                                                    <div className="img-sec">
                                                        <img
                                                            src="/assets/img/user/group-img.png"
                                                            className="img-fluid"
                                                        />
                                                    </div>
                                                </Link>
                                                <Link to="#" className="tutor-text">
                                                    Create one-to-one Course
                                                </Link>
                                            </div>
                                        </div> */}

                                        <div className="col-lg-6 col-md-6 mb-4 d-flex justify-content-center">
                                            <Link to="/tutor/course-list"></Link>
                                            <div className="tutor-card-sec tutor-card-two">
                                                <Link to="/tutor/group-course-list">
                                                    <div className="img-sec">
                                                        <img
                                                            src="/assets/img/user/studymaterial.png"
                                                            className="img-fluid"
                                                        />
                                                    </div>
                                                </Link>
                                                <Link to="#" className="tutor-text">
                                                    Group Course List
                                                </Link>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6 mb-4 d-flex justify-content-center">
                                            <Link to="/tutor/booked-schedule"></Link>
                                            <div className="tutor-card-sec tutor-card-three">
                                                <Link to="/tutor/booked-schedule">
                                                    <div className="img-sec">
                                                        <img src="/assets/img/user/qwerty.png" className="img-fluid" />
                                                    </div>
                                                </Link>
                                                <Link to="#" className="tutor-text">
                                                    View Booked
                                                    <br />
                                                    &nbsp;&nbsp;&nbsp;Schedules
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </main>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    )
}

export default TutorCourses